import { ReactFlow } from '@xyflow/react';
import styled from 'styled-components';

export const StyledReactFlowEditor = styled(ReactFlow)`
  .react-flow__node.selectable:focus {
    border-color: var(--color-grayscale-black);
  }

  .react-flow__renderer {
    background-color: var(--color-gray-10);
  }

  .react-flow__handle-top {
    background: var(--color-gray-40);
  }

  .react-flow__handle-bottom {
    border-radius: var(--sizes-20);
    padding: 6px;
    background-color: var(--color-grayscale-white);
    border: 1px solid var(--color-gray-40);
  }

  .react-flow__edge-path {
    stroke-width: 1px;
    stroke: var(--color-gray-40);
  }
`;
